import { useEffect, useMemo } from 'react';
import { path, pick, prop } from 'ramda';

import { usePortletConfig } from 'js/components/system/Portlet';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { PGG_CATEGORY_MAP } from 'js/app/components/main/Games/constants';
import { setPggGames } from 'js/app/components/main/Games/store/actions';
import { useGamesDispatch, useGamesSelector } from 'js/app/components/main/Games/store/context';
import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';
import { post } from 'js/utils/fetch.util';

/* eslint-disable camelcase */
export const usePggCategory = () => {
    const dispatch = useGamesDispatch();
    const isMobile = useDeviceSelector(prop('isMobile'));
    const brand = useAppSelector(prop('casinoName'));
    const { pggGameList: pggGameLists, categories } = useGamesSelector();
    const [dTagPggEndpointUrl] = useDynamicTags([DYNAMIC_TAG_NAMES.pggEndpointUrl]);
    const {
        isLoggedIn, username, age, gender, guestId: guest_id
    } = useUserSelector(pick(['isLoggedIn', 'username', 'age', 'gender', 'guestId']));
    const client_type = path(['gamesConfiguration', 'pggClientType'], usePortletConfig());

    const pggCategories = useMemo(() => {
        return categories.reduce((acc, category) => {

            if (category.pgg2?.enabled && !acc.includes(category.name)) {
                acc.push({
                    name: category.name,
                    maxGames: category.pgg2?.maxGames || 10
                });
            }

            return acc;
        }, []);
    }, [categories]);

    useEffect(() => {
        if (!pggCategories.length) {
            return;
        }

        pggCategories.forEach(({ name, maxGames }) => {
            const fetchedList = pggGameLists[name];

            if (fetchedList?.isFetchStarted || fetchedList?.fetched) {
                return;
            }

            dispatch(setPggGames(name, {
                isFetchStarted: true,
                fetched: false
            }));

            return post({
                url: `${dTagPggEndpointUrl}/categories`,
                requestBody: {
                    client_type,
                    guest_id,
                    brand,
                    max_games: maxGames,
                    category_names: [PGG_CATEGORY_MAP[name]],
                    client_platform: isMobile ? 'mobile' : 'web',
                    ...isLoggedIn && { username, age, gender }
                }
            })
                .then(response => {
                    dispatch(setPggGames(name, {
                        isFetchStarted: false,
                        fetched: true,
                        pggGameList: response?.categories?.[0]?.games || []
                    }));
                })
                .catch(() => {
                    dispatch(setPggGames(name, {
                        isFetchStarted: false,
                        fetched: true
                    }));
                });
        });
    }, [
        age, brand, client_type, dTagPggEndpointUrl, dispatch, gender, guest_id,
        isLoggedIn, isMobile, pggCategories, pggGameLists, username
    ]);
};
/* eslint-enable camelcase */
